<div class="features flex sm:flex-row flex-col-reverse">
  <app-statistics-section-1 class="flex-1"></app-statistics-section-1>
  <div class="features__content flex-1">
    <h4 class="mb-2" translate>Features</h4>
    <h2 class="mb-4" translate>Powerful QR Code Generation with Scan Tracking</h2>
    <p class="mb-6" translate>
      Track scans and get detailed analytics to measure the effectiveness of
      your QR codes.
    </p>
    <a [routerLink]="['/', i18nService.language, 'qr-code-generator']" class="primary__btn" translate>Try It Now</a>
  </div>
</div>